import { render, staticRenderFns } from "./TheNavDrawerProfileInfo.vue?vue&type=template&id=1a209049&scoped=true&"
import script from "./TheNavDrawerProfileInfo.vue?vue&type=script&lang=ts&"
export * from "./TheNavDrawerProfileInfo.vue?vue&type=script&lang=ts&"
import style0 from "./TheNavDrawerProfileInfo.vue?vue&type=style&index=0&id=1a209049&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a209049",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VAvatar,VBtn,VSubheader})
